import React from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';
import env from '../../envVariables';

const urlDev = 'https://www.icanopee.fr/telechargement-du-connecteur-js2-dev';
const urlProd = 'https://www.icanopee.fr/telechargement-du-connecteur-dmpconnect-js2';

function CheckConnector() {
  return (
    <Card id="connector_not_running">
      <Card.Header>Connecteur DMP non installé ou non démarré ?</Card.Header>
      <Card.Body>
        <Alert variant="info" className="d-flex align-items-center justify-content-between">
          <span>
            <i className="la la-info-circle mr-1" />
            En attente de l&apos;installation du connecteur
          </span>
          <Spinner animation="border" size="sm" />
        </Alert>
        <Card.Text>
          L&apos;installation préalable du connecteur &quot;DmpConnect-JS2&quot; sur votre poste est nécessaire au fonctionnement de cette application.
        </Card.Text>
        <Card.Text>
          Veuillez cliquer sur le bouton ci-dessous pour être redirigé vers la page de téléchargement.
        </Card.Text>
        <div className="text-center mb-3">
          <Button
            size="lg"
            variant="primary"
            href={Number(env.REACT_APP_PRODUCTON_MODE) === 1 ? urlProd : urlDev}
            target="_blank"
            rel="noopener noreferrer"
          >
            Télécharger
          </Button>
        </div>
        <Card.Text>
          Si le connecteur a déjà été installé, veuillez vous assurer qu&apos;il est en fonctionnement : cf.
          {' '}
          <a
            href="https://www.icanopee.fr/controle-du-connecteur-dmp/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contrôle du connecteur DMP
          </a>
        </Card.Text>
        <Card.Text>
          En cas de problème veuillez contacter le
          {' '}
          <a
            href="https://www.icanopee.fr/solutions/produit-efficience-web/assistance-efficience/"
            target="_blank"
            rel="noopener noreferrer"
          >
            support client
          </a>
          .
        </Card.Text>
      </Card.Body>
    </Card>
  );
}

export default CheckConnector;
